module.exports = __webpack_public_path__ + "img/folder-open-white.67b4146c.svg";